/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';

/**
 * 
 * @export
 * @interface FuturesCreateRequest
 */
export interface FuturesCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    ndvrChainId: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    expirationDate: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    firstNoticeDate?: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    exchange: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    exchangeProductCode: string;
    /**
     * 
     * @type {number}
     * @memberof FuturesCreateRequest
     */
    contractMultiplier: number;
    /**
     * 
     * @type {number}
     * @memberof FuturesCreateRequest
     */
    priceMultiplier: number;
    /**
     * 
     * @type {number}
     * @memberof FuturesCreateRequest
     */
    minTick?: number;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    settlementMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    market?: string;
    /**
     * 
     * @type {string}
     * @memberof FuturesCreateRequest
     */
    underlyingSymbol: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof FuturesCreateRequest
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof FuturesCreateRequest
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof FuturesCreateRequest
     */
    subAssetType?: SubAssetType;
}



/**
 * Check if a given object implements the FuturesCreateRequest interface.
 */
export function instanceOfFuturesCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "ndvrChainId" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "expirationDate" in value;
    isInstance = isInstance && "exchange" in value;
    isInstance = isInstance && "exchangeProductCode" in value;
    isInstance = isInstance && "contractMultiplier" in value;
    isInstance = isInstance && "priceMultiplier" in value;
    isInstance = isInstance && "underlyingSymbol" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;

    return isInstance;
}

export function FuturesCreateRequestFromJSON(json: any): FuturesCreateRequest {
    return FuturesCreateRequestFromJSONTyped(json, false);
}

export function FuturesCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuturesCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'ndvrChainId': json['ndvr_chain_id'],
        'symbol': json['symbol'],
        'description': json['description'],
        'expirationDate': json['expiration_date'],
        'firstNoticeDate': !exists(json, 'first_notice_date') ? undefined : json['first_notice_date'],
        'exchange': json['exchange'],
        'exchangeProductCode': json['exchange_product_code'],
        'contractMultiplier': json['contract_multiplier'],
        'priceMultiplier': json['price_multiplier'],
        'minTick': !exists(json, 'min_tick') ? undefined : json['min_tick'],
        'settlementMethod': !exists(json, 'settlement_method') ? undefined : json['settlement_method'],
        'market': !exists(json, 'market') ? undefined : json['market'],
        'underlyingSymbol': json['underlying_symbol'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': !exists(json, 'sub_asset_type') ? undefined : SubAssetTypeFromJSON(json['sub_asset_type']),
    };
}

export function FuturesCreateRequestToJSON(value?: FuturesCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'ndvr_chain_id': value.ndvrChainId,
        'symbol': value.symbol,
        'description': value.description,
        'expiration_date': value.expirationDate,
        'first_notice_date': value.firstNoticeDate,
        'exchange': value.exchange,
        'exchange_product_code': value.exchangeProductCode,
        'contract_multiplier': value.contractMultiplier,
        'price_multiplier': value.priceMultiplier,
        'min_tick': value.minTick,
        'settlement_method': value.settlementMethod,
        'market': value.market,
        'underlying_symbol': value.underlyingSymbol,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
    };
}

